import { createMetricsFactory } from 'metrics-js';

export const UIAUMetrics = createMetricsFactory('ui-addon-upgrades', {
  library: 'ui-addon-upgrades',
});

export const trackUpgradePointTooltipFailure = (upgradeKey: string) => {
  UIAUMetrics.counter('locked-feature-tooltip-failure', {
    upgradeKey,
  }).increment();
};

export const trackApiFailure = ({
  caller,
  statusCode,
  upgradeKey,
}: {
  caller: string;
  statusCode: number | string;
  upgradeKey: string;
}) => {
  UIAUMetrics.counter('api-failure', {
    caller,
    status_code: String(statusCode),
    upgradeKey,
  }).increment();
};
